import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";

const PasswordUser = ({
	childPw,
	stateHelper,
	stateDiss,
	stateShowPassword,
	onChangePassword,
	onKeypressPassword,
	handleClickShowPassword,
}) => {
	return (
		<>
			<FormControl required={true} variant="filled" style={{ width: "100%", backgroundColor: "#00000017" }}>
				<InputLabel htmlFor="standard-adornment-password">Clave</InputLabel>
				<Input
					name="Password"
					inputRef={childPw}
					error={stateHelper.epw}
					helpertext={stateHelper.tpw}
					disabled={stateDiss.dpw}
					onChange={onChangePassword}
					onKeyPress={onKeypressPassword}
					type={stateShowPassword}
					style={{ width: "100%" ,paddingLeft:"15px"}}
                    fullWidth={true}
                    
					endAdornment={
						<InputAdornment position="end">
							<IconButton
								aria-label="toggle password visibility"
								onClick={handleClickShowPassword}
							>
								{stateShowPassword === "text" ? (
									<Visibility />
								) : (
									<VisibilityOff />
								)}
							</IconButton>
						</InputAdornment>
					}
				/>
			</FormControl>
		</>
	);
};
export default PasswordUser;